<template>
  <Dialog :open="open" @close="$emit('close')" width="480px">
    <template v-slot:title>
      <FlexRow justify="center" full-width>
        <Label text="送信前に選考ステータスをご選択ください" size="h5" bold />
      </FlexRow>
    </template>
    <FlexRow justify="center" full-width>
      <!--
       ダイアログの開閉でラジオボタンの表示を切り替える必要はないが、
       selectedStatusをundefinedに変更してもラジオボタンが再レンダリングされないため、
       ダイアログの開閉に合わせてv-if=openでラジオボタンを無理やりレンダリングしている
      -->
      <RadioField
          v-if="open"
          :value="selectedStatus"
          :items="candidateStatus"
          :highlight="status"
          @input="value => selectedStatus = value.select"
      />
    </FlexRow>
    <template v-slot:actions>
      <FlexRow justify="center" full-width>
        <Button color="primary" :disabled="selectedStatus === undefined" @click="$emit('post', selectedStatus)">
          メッセージを送信する
        </Button>
      </FlexRow>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "../atoms/Dialog";
import FlexRow from "../atoms/FlexRow";
import Button from "../atoms/Button";
import {jobApplicationStatus} from "../../enums";
import Label from "../atoms/Label";
import RadioField from "../atoms/RadioField";
export default {
  name: "MessagePostConfirmDialog",
  components: {RadioField, Label, Button, FlexRow, Dialog},
  props: {
    open: {
      type: Boolean,
      required: true
    },
    side: {
      type: Boolean,
    },
    status: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      selectedStatus: undefined
    }
  },
  computed: {
    candidateStatus () {
      if (this.side) {
        return jobApplicationStatus.side
      }
      return jobApplicationStatus.regular
    },
  },
  watch: {
    open: {
      handler() {
        this.selectedStatus = undefined
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>
